<div class="group" [ngStyle]="{ 'justify-content':  alignment }">
  <ng-content></ng-content>
</div>
